// useAiAccounting.ts
import { useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";

export type GlEntry = {
  account_code: string;
  transaction_date: string; // YYYY-MM-DD
  period_year: number;
  period_month: number;
  reference: string;
  amount: number; // +debit, -credit
  description?: string;
};

type AiGlInsertResponse = {
  success: boolean;
  message: string;
  data?: {
    company_id: number;
    total_entries_count: number;
    invoices_count: number;
    invoices: { reference: string; entries_count: number; total_amount: string }[];
    inserted_entries: { account_code: string; amount: number; reference: string }[];
  };
  error?: string;
  details?: any;
};

// type AiGlDeleteResponse = {
//   success: boolean;
//   message: string;
//   data?: {
//     company_id: number;
//     voucher_number: string;
//     deleted_count: number;
//   };
//   error?: string;
//   expiredAt?: string;
// };

export const useInsertGlEntries = () => {
  const mutation = useMutation({
    mutationFn: async (payload: { glEntries: GlEntry[] }) => {
        payload.glEntries.forEach(entry => {
            entry.description = entry.amount > 0 ? "Debit Entry" : "Credit Entry";
        });
      const res = await api.post<AiGlInsertResponse>("/integration/insert-gl-entries", payload);
      return res.data;
    },
    onSuccess: (data) => {
      return data;

      // Optionally, you can refresh your invoices query if it depends on GL data
      // queryClient.invalidateQueries({ queryKey: ["downloaded-e-invoices"] });
    },
  });

  return mutation;
};
